import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import UsuariosView from './UsuariosView';
import * as ROUTES from '../../../router/Routes';

const UsuariosModule = () => {
  return (
    <ContainerTemplate active={ROUTES.usuarios} routes={[]}>
      <UsuariosView />
    </ContainerTemplate>
  );
};

export default UsuariosModule;
